<template>
  <Wrapper>
    <CommonQuestion></CommonQuestion>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/sp/Wrapper";
import CommonQuestion from "../../../components/sp/faq/CommonQuestion";
export default {
  components: {
    Wrapper,
    CommonQuestion,
  },
  name: "FrequentlyAskedQuestions",
};
</script>



// WEBPACK FOOTER //
// src/pages/sp/faq/Question.vue